import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { makeGetSeoTextsBlocksItems } from 'selectors';

import InnerHTML from 'components/InnerHTML';

import { Wrapper, Blocks, Title } from './styles';

const getSeoTextsBlocksItems = makeGetSeoTextsBlocksItems();

const SeoTextsBlocks = ({ match, location }) => {
  const intl = useIntl();

  const selectorProps = {
    intl,
    match,
    location,
  };

  const seoTextsBlocksItems = useSelector(state =>
    getSeoTextsBlocksItems(state, selectorProps)
  );

  if (!seoTextsBlocksItems.length) {
    return null;
  }

  return (
    <Wrapper>
      <Blocks>
        {seoTextsBlocksItems.map(({ id, description, title }) => (
          <Fragment key={id}>
            {title && <Title>{title}</Title>}
            <InnerHTML html={description} className="InnerHTML" />
          </Fragment>
        ))}
      </Blocks>
    </Wrapper>
  );
};

SeoTextsBlocks.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.objectOf(PropTypes.string).isRequired,
  }).isRequired,
};

export default withRouter(SeoTextsBlocks);
